export default __webpack_public_path__ + "static/header-logo-stick-3d6620fe15ee5c13470292afa376c3e2.svg";